var scope_0 = require('/builds/honza.kopecky95/gdm-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/01f9011daa2a97f50170acbcea39f093.js').default;
var scope_1 = require('/builds/honza.kopecky95/gdm-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8d8ee8e8923034451fa0c2eaf6c91277.js').default;
var scope_2 = require('/builds/honza.kopecky95/gdm-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9c62ba231d68dcd4ab5c6dfc28d23eb1.js').default;
var scope_3 = require('/builds/honza.kopecky95/gdm-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    